import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProfileService } from '@tenant/core';
import { flyInOut } from '@tenant/ot';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const SALES_URL = '/deal/create/sales';
export const RENTAL_URL = '/deal/create/rental';

@Component({
  selector: 'ot-deal-type-select',
  templateUrl: './deal-type-select.component.html',
  styleUrls: ['./deal-type-select.component.scss'],
  animations: [flyInOut],
})
export class DealTypeSelectComponent {
  public get current() {
    return this.available.find((v) => this.router.isActive(v.url[0], false));
  }

  public get choosable() {
    return this.available;
  }

  public available = [
    { label: 'Sales', url: [SALES_URL] },
    { label: 'Rental', url: [RENTAL_URL] },
  ];
  public showMenu: boolean;
  public hasOpts$: Observable<any>;

  constructor(private router: Router, private profile: ProfileService) {
    this.hasOpts$ = profile.state.pipe(
      map((v: any) => {
        return true;
      })
    );
  }

  close() {
    this.showMenu = false;
  }

  public toggleMenu() {
    this.showMenu = !this.showMenu;
  }
}
